import Icon, { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

function Svg({ className, style }: Partial<CustomIconComponentProps>) {
  return (
    <svg width="21" height="32" viewBox="0 0 440 658" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
    <path d="M355.656 442.296C355.656 515.896 294.623 575.794 219.629 575.794C156.447 575.794 101.32 532.583 87.1806 472.509L6.10103 485.507L4.49017 485.859C25.2523 585.631 115.818 658 219.629 658C340.8 658 439.241 561.39 439.241 442.472V416.651L355.656 430V442.472V442.296Z" fill="url(#paint0_linear_986_7981)"/>
    <path d="M0 215.528C0 334.447 98.441 431.057 219.613 431.057C340.785 431.057 439.226 334.447 439.226 215.528C439.226 165.115 421.506 118.743 391.795 82.0308H439.942V0H219.613C98.441 0 0 96.6101 0 215.528ZM355.641 215.528C355.641 289.128 294.607 349.026 219.613 349.026C144.619 349.026 83.5854 289.128 83.5854 215.528C83.5854 141.929 144.619 82.0308 219.613 82.0308C294.607 82.0308 355.641 141.929 355.641 215.528Z" fill="url(#paint1_linear_986_7981)"/>
    <defs>
    <linearGradient id="paint0_linear_986_7981" x1="-54.9324" y1="536.974" x2="2201.7" y2="-966.366" gradientUnits="userSpaceOnUse">
    <stop stop-color="#00CBEB"/>
    <stop offset="0.144231" stop-color="#C375FF"/>
    <stop offset="0.620192" stop-color="#FC63D7"/>
    </linearGradient>
    <linearGradient id="paint1_linear_986_7981" x1="6.76942e-06" y1="215.528" x2="1736.61" y2="-967.979" gradientUnits="userSpaceOnUse">
    <stop stop-color="#00CBEB"/>
    <stop offset="0.144231" stop-color="#C375FF"/>
    <stop offset="0.552885" stop-color="#FC63D7"/>
    </linearGradient>
    </defs>
    </svg>
  );
}

export default function Graph8Logo(props: Partial<CustomIconComponentProps>) {
  return <Icon component={Svg} {...props} />;
}
